module.exports = __webpack_public_path__ + "media/images/icons/benefit_gateway-ba19b27efaeb388000801aa088cffba0.svg";